import { flagColor } from '../../settings/routes/AdapterRoutingCoverage/labels'
import { ClientRoutingDisabledReason, ClientRoutingWarning } from './_rest_models'

/**
 * CPAYMENT-1498: словари блока «Маршрутизация» в карточке клиента.
 *
 * Флаг локализуется через intl (`client.flag.<color>`) — тем же словарём, что и селект флага
 * на этой же странице; цвет дота берём из общего справочника маршрутизации, чтобы флаг выглядел
 * одинаково здесь и на экране покрытия адаптеров.
 */
export { flagColor }
export { SOURCE_LABEL } from '../../settings/routes/AdapterRoutingCoverage/labels'

/**
 * Заголовки направлений по ТЗ карточки клиента («Депозиты» / «Выплаты»).
 * Намеренно НЕ переиспользуем DIRECTION_LABEL («Приём» / «Выплата») из экрана покрытия:
 * там это ось конфигурации, здесь — раздел карточки в терминах постановки.
 */
export const ROUTING_DIRECTION_TITLE: Record<'PAYMENT' | 'PAYOUT', string> = {
  PAYMENT: 'Депозиты',
  PAYOUT: 'Выплаты',
}

export const ROUTING_DIRECTION_HINT: Record<'PAYMENT' | 'PAYOUT', string> = {
  PAYMENT: 'куда уходят платежи клиента',
  PAYOUT: 'откуда уходят выплаты клиенту',
}

export const ROUTING_DISABLED_REASON: Record<ClientRoutingDisabledReason, string> = {
  RULE_DISABLED: 'правило выключено',
  ADAPTER_DISABLED: 'адаптер выключен',
  TRAFFIC_TYPE: 'правило для другого типа трафика',
  CONTEXT_DISABLED: 'конфигурация маршрутизации выключена',
}

export const ROUTING_WARNING_TEXT: Record<ClientRoutingWarning, string> = {
  LOCAL_WITHOUT_CASHBOX:
    'Свои кассы стоят в цепочке, но рабочих касс по флагу нет — реквизит по ним выдан не будет',
  ALL_CASHBOXES_BLOCKED: 'Все кассы по этому флагу заблокированы — выплата по ним не пройдёт',
  CASHBOX_BALANCE_ACCOUNTING:
    'У части касс включён учёт баланса: заявку больше остатка с овердрафтом такая касса не возьмёт, и её пропустят',
  AMOUNT_DEPENDENT_FALLBACK:
    'Правила флага покрывают не весь диапазон сумм: вне покрытия каскад возьмётся из конфигурации white',
  NO_ADAPTER_WITHOUT_AMOUNT:
    'Всем адаптерам цепочки нужна сумма: депозит, созданный без суммы, по ней не пойдёт',
}

/** Информационные предупреждения не красим красным — иначе красное перестают читать. */
export const ROUTING_WARNING_SEVERITY: Record<ClientRoutingWarning, 'danger' | 'warning' | 'info'> = {
  LOCAL_WITHOUT_CASHBOX: 'danger',
  ALL_CASHBOXES_BLOCKED: 'danger',
  CASHBOX_BALANCE_ACCOUNTING: 'info',
  AMOUNT_DEPENDENT_FALLBACK: 'info',
  NO_ADAPTER_WITHOUT_AMOUNT: 'info',
}

const CURRENCY_SYMBOL: Record<string, string> = {
  RUB: '₽',
  UAH: '₴',
  KZT: '₸',
  KRW: '₩',
  USD: '$',
  EUR: '€',
  AZN: '₼',
}

/** Для крипто- и прочих пар символа нет — показываем код валюты как есть. */
export function currencySymbol(currency: string): string {
  return CURRENCY_SYMBOL[currency] ?? currency
}

export function pluralize(count: number, one: string, few: string, many: string): string {
  const mod10 = count % 10
  const mod100 = count % 100

  if (mod10 === 1 && mod100 !== 11) return one
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return few

  return many
}
